"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("rect", {
      x: "3.0918",
      y: "2.70215",
      width: "14.4121",
      height: "14.4121",
      stroke: "currentColor",
      strokeWidth: "1.2",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M4.72006 15.4542C5.14442 15.8785 5.21182 16.4992 5.21182 16.4992C5.21182 16.4992 4.59119 16.4318 4.16682 16.0074C3.74245 15.583 3.67506 14.9624 3.67506 14.9624C3.67506 14.9624 4.29569 15.0298 4.72006 15.4542Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M8.11068 15.4542C8.53505 15.8785 8.60245 16.4992 8.60245 16.4992C8.60245 16.4992 7.98181 16.4318 7.55745 16.0074C7.13308 15.583 7.06568 14.9624 7.06568 14.9624C7.06568 14.9624 7.68632 15.0298 8.11068 15.4542Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11.5013 15.4542C11.9257 15.8785 11.9931 16.4992 11.9931 16.4992C11.9931 16.4992 11.3724 16.4318 10.9481 16.0074C10.5237 15.583 10.4563 14.9624 10.4563 14.9624C10.4563 14.9624 11.0769 15.0298 11.5013 15.4542Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M14.8919 15.4542C15.3163 15.8785 15.3837 16.4992 15.3837 16.4992C15.3837 16.4992 14.7631 16.4318 14.3387 16.0074C13.9143 15.583 13.8469 14.9624 13.8469 14.9624C13.8469 14.9624 14.4676 15.0298 14.8919 15.4542Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M4.72006 9.53546C5.14442 9.95983 5.21182 10.5805 5.21182 10.5805C5.21182 10.5805 4.59119 10.5131 4.16682 10.0887C3.74245 9.66433 3.67506 9.04369 3.67506 9.04369C3.67506 9.04369 4.29569 9.11109 4.72006 9.53546Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M8.11068 9.53546C8.53505 9.95983 8.60245 10.5805 8.60245 10.5805C8.60245 10.5805 7.98181 10.5131 7.55745 10.0887C7.13308 9.66433 7.06568 9.04369 7.06568 9.04369C7.06568 9.04369 7.68632 9.11109 8.11068 9.53546Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11.5013 9.53546C11.9257 9.95983 11.9931 10.5805 11.9931 10.5805C11.9931 10.5805 11.3724 10.5131 10.9481 10.0887C10.5237 9.66433 10.4563 9.04369 10.4563 9.04369C10.4563 9.04369 11.0769 9.11109 11.5013 9.53546Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M14.8919 9.53546C15.3163 9.95983 15.3837 10.5805 15.3837 10.5805C15.3837 10.5805 14.7631 10.5131 14.3387 10.0887C13.9143 9.66433 13.8469 9.04369 13.8469 9.04369C13.8469 9.04369 14.4676 9.11109 14.8919 9.53546Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M4.72006 3.96832C5.14442 4.39269 5.21182 5.01332 5.21182 5.01332C5.21182 5.01332 4.59119 4.94592 4.16682 4.52156C3.74245 4.09719 3.67506 3.47656 3.67506 3.47656C3.67506 3.47656 4.29569 3.54395 4.72006 3.96832Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M8.11068 3.96832C8.53505 4.39269 8.60245 5.01332 8.60245 5.01332C8.60245 5.01332 7.98181 4.94592 7.55745 4.52156C7.13308 4.09719 7.06568 3.47656 7.06568 3.47656C7.06568 3.47656 7.68632 3.54395 8.11068 3.96832Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11.5013 3.96832C11.9257 4.39269 11.9931 5.01332 11.9931 5.01332C11.9931 5.01332 11.3724 4.94592 10.9481 4.52156C10.5237 4.09719 10.4563 3.47656 10.4563 3.47656C10.4563 3.47656 11.0769 3.54395 11.5013 3.96832Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M14.8919 3.96832C15.3163 4.39269 15.3837 5.01332 15.3837 5.01332C15.3837 5.01332 14.7631 4.94592 14.3387 4.52156C13.9143 4.09719 13.8469 3.47656 13.8469 3.47656C13.8469 3.47656 14.4676 3.54395 14.8919 3.96832Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M16.0768 12.4949C15.6525 12.9193 15.5851 13.5399 15.5851 13.5399C15.5851 13.5399 16.2057 13.4725 16.6301 13.0482C17.0544 12.6238 17.1218 12.0032 17.1218 12.0032C17.1218 12.0032 16.5012 12.0706 16.0768 12.4949Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M12.6862 12.4949C12.2618 12.9193 12.1944 13.5399 12.1944 13.5399C12.1944 13.5399 12.8151 13.4725 13.2394 13.0482C13.6638 12.6238 13.7312 12.0032 13.7312 12.0032C13.7312 12.0032 13.1106 12.0706 12.6862 12.4949Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.29557 12.4949C8.8712 12.9193 8.8038 13.5399 8.8038 13.5399C8.8038 13.5399 9.42444 13.4725 9.8488 13.0482C10.2732 12.6238 10.3406 12.0032 10.3406 12.0032C10.3406 12.0032 9.71993 12.0706 9.29557 12.4949Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.90494 12.4949C5.48058 12.9193 5.41318 13.5399 5.41318 13.5399C5.41318 13.5399 6.03381 13.4725 6.45818 13.0482C6.88255 12.6238 6.94994 12.0032 6.94994 12.0032C6.94994 12.0032 6.32931 12.0706 5.90494 12.4949Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M16.0768 6.57648C15.6525 7.00084 15.5851 7.62148 15.5851 7.62148C15.5851 7.62148 16.2057 7.55408 16.6301 7.12971C17.0544 6.70535 17.1218 6.08471 17.1218 6.08471C17.1218 6.08471 16.5012 6.15211 16.0768 6.57648Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M12.6862 6.57648C12.2618 7.00084 12.1944 7.62148 12.1944 7.62148C12.1944 7.62148 12.8151 7.55408 13.2394 7.12971C13.6638 6.70535 13.7312 6.08471 13.7312 6.08471C13.7312 6.08471 13.1106 6.15211 12.6862 6.57648Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.29361 6.57648C8.86925 7.00084 8.80185 7.62148 8.80185 7.62148C8.80185 7.62148 9.42248 7.55408 9.84685 7.12971C10.2712 6.70535 10.3386 6.08471 10.3386 6.08471C10.3386 6.08471 9.71798 6.15211 9.29361 6.57648Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.90494 6.57648C5.48058 7.00084 5.41318 7.62148 5.41318 7.62148C5.41318 7.62148 6.03381 7.55408 6.45818 7.12971C6.88255 6.70535 6.94994 6.08471 6.94994 6.08471C6.94994 6.08471 6.32931 6.15211 5.90494 6.57648Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;